export enum ReportParamsEnum {
  INCLUDE_SENSORS = 'includeSensors',
  ZONE_VISITS_ZONES = 'zones',
  INCLUDE_ZONES = 'includeZones',
  ONLY_DRIVING_STATE = 'onlyDrivingState',
  GROUP_BY_DAYS = 'groupByDays',
  AGGREGATION_TYPE = 'aggregationType',
  BUSINESS_DRIVE_TIME_INDICATOR = 'businessDriveTimeIndicator',
  IS_REGION_FILTERABLE = 'regionFilter',
  SHOULD_CONTAIN_DETAILED_ROUTE_DESCRIPTION = 'shouldContainDetailedRouteDescription',
  SHOULD_INCLUDE_MTH_AND_FUELLEVEL = 'shouldIncludeMthAndFuelLevel',
  INCLUDE_FUEL_DATA = 'includeFuelData',
  INCLUDE_RPM = 'includeRpm',
}
